export default __webpack_public_path__ + "static/media/logo-syvideo.e0002591.svg";